<script>
    /*
    	ClearFiltersButton.svelte

    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let onClick;

    onMount(() => {
    })

</script>

<style>

    .clear-button button {
        width: 100px;
        padding: 8px 5px;
        font-size: 14px;
        color: var(--tcui-primary);
        background: none;
        border-radius: 16px;
        border: 1px solid #F8F3F8;
        border-radius: 35px;    
    }

    .clear-button button:hover {
        background-color: var(--tcui-ruby-light);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="clear-button">
    <button on:click={onClick}>Clear Filters</button>
</div>
